export const ON_CONTACT_CHANGE = '@ARI/Questionnaire/Contact/ON_CONTACT_CHANGE';
export const ON_CONTACT_BLUR = '@ARI/Questionnaire/Contact/ON_CONTACT_BLUR';
export const SET_CONTACT_VALIDATORS = '@ARI/Questionnaire/Contact/SET_CONTACT_VALIDATORS';
export const SET_CONTACT_VALUES = '@ARI/Questionnaire/Contact/SET_CONTACT_VALUES';
export const SET_CONTACT_SETTINGS = '@ARI/Questionnaire/Contact/SET_CONTACT_SETTINGS';
export const SET_CONTACT_ERRORS = '@ARI/Questionnaire/Contact/SET_CONTACT_ERRORS';